import { getProxyUrl, getPublicLang } from 'academy-common-lib/utils/url';
// @ts-expect-error Could not find a declaration file for module
import defaultShareImage from 'bender-url!../../images/default-share-image.png';
import PublicPageLayout from '../features/publicLayout/components/PublicPageLayout';
import { supportedPublicLanguages } from 'academy-common-lib/constants/academySupportedLanguages';
import DocumentHead from '../features/publicSeo/components/DocumentHead';
import { NavMarker } from 'react-rhumb';
import OpenGraph from '../features/publicSeo/components/OpenGraph';
import I18n from 'I18n';
import { useEffect } from 'react';
import usageTracker from '../utils/usageTracker';
import { Paths } from './RoutingConstants';
import AlternateLanguageLinks from '../features/publicSeo/components/AlternateLanguageLinks';
import PublicPageHeader from '../features/publicLayout/components/PublicPageHeader';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { NUMBER_OF_USERS_CERTIFIED } from 'academy-common-lib/constants/general';
// @ts-expect-error img
import certificationsHeaderBadge from 'bender-url!../../images/certifications-header-badge.svg';
import { Image } from 'foundations-components/transitional/components/Image';
import WhyGetCertifiedSection from '../features/staticSections/WhyGetCertifiedSection';
import CertificationProcessSection from '../features/staticSections/CertificationProcessSection';
import { useCertificationsResults } from '../features/certificationOverviewPage/certificationOverviewHooks';
import { PublicCatalogResultsDisplay } from '../features/publicCatalog/components/PublicCatalogResults';
import HorizontalLayoutContainer from '../features/publicLayout/components/HorizontalLayoutContainer';
import ErrorBoundary from '../components/ErrorBoundary';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CertificationOverviewPage = () => {
  const {
    certificationsData,
    certificationsLoading,
    certificationsError
  } = useCertificationsResults();
  useEffect(() => {
    document.title = I18n.text('academyPublic.certificationOverviewPage.pageTitle');
    usageTracker.track('pageView', {
      screen: 'certification-overview-page',
      subscreen: 'certification-overview-page'
    });
  }, []);
  return /*#__PURE__*/_jsxs(PublicPageLayout, {
    availableLanguages: [...supportedPublicLanguages],
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "CERTIFICATION_OVERVIEW_PAGE_LOAD"
    }), window.prerenderReady = true, /*#__PURE__*/_jsxs(DocumentHead, {
      children: [/*#__PURE__*/_jsx("link", {
        href: getProxyUrl(Paths.CERTIFICATION_OVERVIEW),
        rel: "canonical"
      }), /*#__PURE__*/_jsx(AlternateLanguageLinks, {
        languages: [...supportedPublicLanguages]
      }), /*#__PURE__*/_jsx("meta", {
        content: "",
        name: "description"
      }), /*#__PURE__*/_jsx(OpenGraph, {
        description: "",
        image: defaultShareImage.replace('//', 'https://'),
        imageAlt: I18n.text('academyPublic.defaultThumbnailAltText'),
        title: I18n.text('academyPublic.certificationOverviewPage.pageTitle'),
        url: getProxyUrl(Paths.CERTIFICATION_OVERVIEW)
      })]
    }), /*#__PURE__*/_jsx(PublicPageHeader, {
      badgeText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.certificationOverviewPage.badgeText"
      }),
      description: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.certificationOverviewPage.description1"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "academyPublic.certificationOverviewPage.description2",
            options: {
              numberOfUsersCertified: /*#__PURE__*/_jsx(FormattedNumber, {
                value: NUMBER_OF_USERS_CERTIFIED
              })
            }
          })
        })]
      }),
      heading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.certificationOverviewPage.heading"
      }),
      rightContent: /*#__PURE__*/_jsx(Image, {
        alt: I18n.text('academyPublic.certificationOverviewPage.badgeAltText'),
        src: certificationsHeaderBadge
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "1200",
      children: /*#__PURE__*/_jsx(HorizontalLayoutContainer, {
        children: /*#__PURE__*/_jsx(ErrorBoundary, {
          children: /*#__PURE__*/_jsx(PublicCatalogResultsDisplay, {
            data: certificationsData,
            disablePaginator: true,
            error: certificationsError,
            language: getPublicLang(),
            loading: certificationsLoading
          })
        })
      })
    }), /*#__PURE__*/_jsx(WhyGetCertifiedSection, {}), /*#__PURE__*/_jsx(CertificationProcessSection, {})]
  });
};
export default CertificationOverviewPage;